import {Component, OnInit} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {CommonService} from 'src/app/shared/services/common.service';
import {environment} from 'src/environments/environment.generated';
import {getAppThemeName} from "../../core/functions/common.function";
import {DBAlertModule} from "@db/db-core";
import {KeepHtmlPipe} from "../../shared/pipes/keep-html.pipe";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-connect-cidp',
  templateUrl: './entitlements-error-page.component.html',
  styleUrls: ['./entitlements-error-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DBAlertModule,
    TranslateModule,
    KeepHtmlPipe
  ]
})
export class EntitlementsErrorPageComponent implements OnInit {

  public appUrl: string = environment.appUrl;
  public isLoading = true;

  constructor(
    private readonly appService: CommonService,
    private readonly translate: TranslateService,
  ) {
  }

  ngOnInit() {
    this.appService._languageData.subscribe(data => {
      this.translate.use(data.activeLang);
      this.isLoading = false;
    });
  }

  protected readonly getAppThemeName = getAppThemeName;
  protected readonly sessionStorage = sessionStorage;
}
